import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./Country.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import {
  GridRenderCellParams,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { ICountry } from "./ICountry";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import CountryForm from "./CountryForm";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";
import { listCountry } from "../../Redux/Slices/Country/ListCountrySlice";
import { clearAddCountryResponse } from "../../Redux/Slices/Country/AddCountrySlice";
import {
  clearDeleteCountryResponse,
  deleteCountry,
} from "../../Redux/Slices/Country/DeleteCountrySlice";
import { clearEditCountryResponse } from "../../Redux/Slices/Country/EditCountrySlice";
import { listSideMenuPermission } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import { listCountryList } from "../../Redux/Slices/ExterAPI/ListCountryListSlice";

interface CountryProps { }

const Country: FunctionComponent<CountryProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<ICountry | {}>({
    status: true,
  });
  const dispatch = useAppDispatch();
  const { data: listCountrys } = useAppSelector(
    (state) => state.ListCountrySlice
  );
  const { data: addCountry } = useAppSelector((state) => state.AddCountrySlice);
  const { data: EditCountry } = useAppSelector(
    (state) => state.EditCountrySlice
  );
  const { data: deleteCountrys } = useAppSelector(
    (state) => state.DeleteCountry
  );

  const permissions = useAppSelector((state) => state.PermissionsToPage);
  const finaldata = { permissions };

  const formRef = useRef<HTMLFormElement>(null);
  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "region",
      renderHeader: () => <b>Country</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "state",
      renderHeader: () => <b>State</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    // {
    //   field: "timezone",
    //   renderHeader: () => <b>Time Zone</b>,
    //   flex: 1,
    //   type: "string",
    //   headerAlign: "left",
    // },
    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,

      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<ICountry>) => {
        return (
          <>
            <IconButtonField
              disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                setInitialValues({ ...params.row, id: params.id as number });
                setIsEdit(true);
                setDialogOpen(true);
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              disabled={finaldata?.permissions?.delete === false}
              onClick={() => {
                setDeleteData({ id: params.id, name: params?.row?.region });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  const Country = Array.isArray(listCountrys?.data)
    ? listCountrys?.data.map((user, index) => ({ ...user, index: index + 1 }))
    : [];

  useEffect(() => {
    dispatch(listCountry());
    dispatch(listCountryList());

    // dispatch(listSideMenuPermission());
  }, [addCountry, EditCountry, deleteCountrys, dispatch]);
  useEffect(() => {
    return () => {
      dispatch(clearAddCountryResponse());
      dispatch(clearEditCountryResponse());
      dispatch(clearDeleteCountryResponse());
    };
  }, [dispatch]);
  return (
    <>
      <Table rows={Country ?? []} columns={columns} exportFileName="Countries">
        <CustomToolbar>
          <h6></h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => {
              setInitialValues({ status: true });
              setIsEdit(false);
              setDialogOpen(true);
            }}
            toolTip="Add new"
            disabled={finaldata?.permissions?.add === false}
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(listCountry())}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog"
        Dialog_Title={`${isEdit ? "Update" : "Add"} Country`}
        dialogContentClassName="dialog_content"
        Dialog_Content={
          <CountryForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => {
                setDialogOpen(false);
                setIsEdit(false);
              }}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />
      <ResponseDialog response={addCountry} parentDialog={setDialogOpen} />
      <ResponseDialog response={EditCountry} parentDialog={setDialogOpen} />
      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          dispatch(deleteCountry(deleteDialogData.id));
        }}
        response={deleteCountrys}
      />
    </>
  );
};

export default Country;
